import { useMemo } from 'react';
import { Provider, useDispatch, useSelector, useStore } from 'react-redux';
import { Modal } from 'antd';
import { modalViewAction } from '../../../appRedux/actions/Ui';
import { createModalStore } from '../../../appRedux/store/modal';
import './styles.css';

const ModalContent = ({ children }) => {
  const parentStore = useStore();
  const store = useMemo(() => createModalStore(parentStore), [parentStore]);

  return <Provider store={store}>{children}</Provider>;
};

export const ModalView = ({ title, width, children, open, onCancel }) => {
  const { modalView } = useSelector((state) => state.ui);
  const dispatch = useDispatch();
  const isOpen = open ?? modalView;
  const handleCancel = onCancel ?? (() => dispatch(modalViewAction(false)));

  return (
    <Modal
      title={<h2>{title}</h2>}
      open={isOpen}
      destroyOnClose
      onCancel={handleCancel}
      width={width ?? 'auto'}
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{ style: { display: 'none' } }}
      style={{ maxWidth: '1400px' }}
    >
      <ModalContent>{children}</ModalContent>
    </Modal>
  );
};
